module.exports = __webpack_public_path__ + "static/media/W1@1.5x.9dbe6aaf.png";